import React from 'react';
import { Mafs, Polygon, Theme } from 'mafs';

export const PlaceValueBlocks = ({ config, variables }) => {
    // Clamp to 0-999 for visual safety
    const rawNum = variables['number'] || config.number || 123;
    const number = Math.max(0, Math.min(999, Number(rawNum)));

    const hundreds = Math.floor(number / 100);
    const tens = Math.floor((number % 100) / 10);
    const ones = number % 10;

    const shapes = [];
    let currentX = 0;
    const GAP = 2; // Gap between place value groups

    // 1. Hundreds (10x10 squares)
    for (let i = 0; i < hundreds; i++) {
        shapes.push(
            <Polygon
                key={`h-${i}`}
                points={[[currentX, 0], [currentX + 10, 0], [currentX + 10, 10], [currentX, 10]]}
                color={Theme.blue} fillOpacity={0.4} strokeWidth={1}
            />
        );
        // Add grid lines for detail (optional but nice for pedagogy)
        currentX += 11; // 10 width + 1 gap
    }
    if (hundreds > 0) currentX += GAP;

    // 2. Tens (1x10 strips)
    for (let i = 0; i < tens; i++) {
        shapes.push(
            <Polygon
                key={`t-${i}`}
                points={[[currentX, 0], [currentX + 1, 0], [currentX + 1, 10], [currentX, 10]]}
                color={Theme.green} fillOpacity={0.4} strokeWidth={1}
            />
        );
        currentX += 2; // 1 width + 1 gap
    }
    if (tens > 0) currentX += GAP;

    // 3. Ones (1x1 small squares)
    // Stack them in columns of 5 for readability
    const startOnesX = currentX;
    for (let i = 0; i < ones; i++) {
        const col = Math.floor(i / 5);
        const row = i % 5;
        const x = startOnesX + (col * 2);
        const y = row * 2; // Spaced out vertically

        shapes.push(
            <Polygon
                key={`o-${i}`}
                points={[[x, y], [x + 1, y], [x + 1, y + 1], [x, y + 1]]}
                color={Theme.red} fillOpacity={0.6} strokeWidth={1}
            />
        );
    }
    // Update width if ones were added
    if (ones > 0) currentX += Math.ceil(ones / 5) * 2;

    const totalWidth = Math.max(15, currentX);
    // Center vertically: max height is 10
    const viewBoxY = [-2, 12];

    return (
        <Mafs viewBox={{ x: [-1, totalWidth], y: viewBoxY }} pan={false}>
            {shapes}
        </Mafs>
    );
};